var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    width: "80px",
    height: "80px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8bb7f0",
    d: "M40 2A38 38 0 1 0 40 78A38 38 0 1 0 40 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.784 44.013c.006-.054.016-.106.021-.159C77.8 43.907 77.79 43.96 77.784 44.013zM2.194 43.84c.007.073.021.144.029.217C2.215 43.985 2.201 43.912 2.194 43.84zM44.907 50.471h9.835l1.544-9.989H44.907v-5.46c0-4.149 1.356-7.83 5.239-7.83h6.238v-8.719C55.287 18.325 52.97 18 48.59 18c-9.146 0-14.507 4.831-14.507 15.835v6.647h-9.402v9.989h9.402V77.4c1.858.279 3.744.47 5.68.47 1.749 0 3.458-.159 5.144-.388V50.471z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M40,3c20.402,0,37,16.598,37,37S60.402,77,40,77S3,60.402,3,40S19.598,3,40,3 M40,2 C19.013,2,2,19.013,2,40s17.013,38,38,38s38-17.013,38-38S60.987,2,40,2L40,2z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.d5710adc93089b65d33182b773673984.svg";
export { ForwardRef as ReactComponent };